import React from 'react';
import {Image, Carousel, Button} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import snacks from './DealsDB'
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Snacks from './Snacks'
import Curries from './GCurriesDB'
import Icurries from './ICurriesDB';
import DrinksDB from './DrinksDB';
import {useEffect, useState, useContext} from 'react';
import RiceDB from './RiceDB'
import Snack1DB from './Snack1DB'
import Cart from './Cart.js'
import CartContext from '../Context/CartContext';
import { FixedSizeList } from 'react-window';
import ShowCart from './ShowCart';
import HowItWorks from './HowItWorks';
import { useParams } from "react-router-dom";
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import CollectionsIcon from '@mui/icons-material/Collections';
import { SiCodechef } from "react-icons/si";
import   OrderChoris from "./OrderChoris";
import OnlineItems from './OnlineMenu/OnlineItems';
import OnlineCart from "./OnlineMenu/OnlineCart";
import CircularProgress from '@mui/material/CircularProgress';

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    alignContent:'right',
    color: theme.palette.text.secondary,
    boxShadow: "none",
   
  
    
  }));
const Banner = () => {
    const paperStyle ={
        padding: '30px 20px', 
        margin: '20px auto',
        backgroundColor:"#FFB81C"
      }
      const menuStyle ={
        padding: '30px 20px', 
        width: {xs:"100%", md:"100%"},
        margin: '20px auto',
        backgroundColor:"white"
      }

      const deactive ={
          backgroundColor:"white",
          color:"black",
          marginRight:"10px",
          border: '1px black solid',
          marginBottom:"10px",
          borderRadius:"0px"
      }

      const active = {
        backgroundColor:"#8B0000",
        color:"white",
        marginRight:"10px",
        marginBottom:"10px",
        border: '1px black solid',
        borderRadius:"0px"
      }
      //taking out snacks correction
    
      const [loading, setLoading] = useState([]);
      const [items, setItems] = useState([])
      const [mealType, setMealType] = useState("");
      const { name } = useParams();
      useEffect(() =>{
        let temp = name;
        setTimeout(()=>setMealType(temp), 100);
      },[name])

      useEffect(()=>{
        if(mealType) {
            switch(mealType.toLowerCase()) {
                    case "goan":
                        getItems(mealType);
                        break;
                    case "snacks":
                        getItems(mealType);
                        break
                    case "drinks":
                        getItems(mealType);
                        break
                    case "indian":
                        getItems(mealType);
                        break
                    case "rice":
                        getItems(mealType);
                        break
                    default:
                        getItems("snacks");
                        setMealType('snacks');

            } 

         } else {
            setMealType('snacks');
            getItems("snacks");
        }
      },[mealType])

    const getItems = (item) =>{
        setLoading(true);
        setItems([]);
        fetch(`https://nosk.billfern.ca/api/get_${item}`)
        .then((response)=> response.json() )
        .then(data => { setItems([...data.slots]); setLoading(false)})
        .catch(e => {console.log(e); setLoading(false) })
    }

  
    


      
  return (
    <div>

        
          {loading ? <CircularProgress style={{color:"#8B0000"}}/> : <>   

        <Typography variant="h3" component="div" gutterBottom style={{color:"black"}}>
                   Menu
                </Typography> 
                {/* correction taking out snacks button */}
                {/* <Button style={oneFlag === true ? active : deactive}
                  onClick={changeOneFlag}
                >Snacks</Button> */}
                <Button style={mealType === "snacks" ? active : deactive}
                    onClick={()=>setMealType('snacks')}
                >Snacks </Button> 
                <Button style={mealType === "goan" ? active : deactive}
                  onClick={()=>setMealType('goan')}
                   >Goan Menu</Button>
                <Button style={mealType === "indian"? active : deactive}
                   onClick={()=>setMealType('indian')}
                 >Indian Menu</Button>
                <Button style={mealType === "drinks"? active : deactive}
                   onClick={()=>setMealType('drinks')}
                  >Drinks & Desserts</Button>  
                   <Button style={mealType === "rice" ? active : deactive}
                    onClick={()=>setMealType('rice')}
                    > Rice Menu
                    </Button>   
                   
                    <Typography variant="h5" component="div" gutterBottom
                        style={{fontSize:"20px"}}
                        >
                            <b>Call us to place order: (416) 792-7060</b> <br />
                            <b>Text us to place order: (647) 863-9249</b>
                        </Typography>           
                     
                          
        <Paper  elevation={12}  style={paperStyle}>  
             
            <Paper  elevation={24}  sx={menuStyle}>       
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                 {mealType === 'snacks' &&
                    <Grid item xs={12}  >
                        
                        <Typography variant="h5" component="div" gutterBottom
                        style={{fontSize:"30px"}}
                        >
                            <b>Snacks</b>
                        </Typography>
                        <Typography variant="h6" component="div" gutterBottom
                        style={{fontSize:"20px"}}
                        >
                            Order by the dozen
                        </Typography>
                        
                        <Divider/>
                    <Item>
                                   
                        <Stack spacing={2}>
                            <Grid container spacing={0}>
                
                </Grid>

                </Stack> 
                        </Item>
                    </Grid>
                  }
                  {mealType === 'goan' &&
                    <Grid item xs={12}  >
                        <Typography variant="h5" component="div" gutterBottom
                        style={{fontSize:"30px"}}
                        >
                            <b> Goan Menu</b>
                        </Typography>
                        <Divider/>
                    <Item>
                                
                        <Stack spacing={0}>
                            
                            <Grid container spacing={0}>
                   {/* {
                        Curries.map((curry)=>(  
                            <Grid item  xs={12} md={6}>
                                <Item>
                                    <Snacks
                                        key={curry.id} 
                                        id={curry.id} 
                                        name={"Gcurry"} 
                                        snack={curry}
                                        onAddCart={onAddCart}
                                    />                         
                                </Item>
                            </Grid>                
                            ))                  
                        }  */}

                    </Grid>
                    </Stack> 
                        </Item>
                    </Grid>
                  }




                {mealType === 'indian' &&
                    <Grid item xs={12}  >
                    <Item>
                    <Typography variant="h5" component="div" gutterBottom
                        style={{fontSize:"30px"}}
                        >
                            <b>

                            Indian Cuisine
                            </b>
                        </Typography>    
                        <Divider/>       
                        <Stack spacing={2}>
                        <Grid container spacing={0}>
                        {

                        Icurries.map((curry)=>(
                            <Grid item  xs={12} md={6}>
                            <Item>
                                <Snacks key={curry.id} id={curry.id} snack={curry}
                                />                        

                            </Item>
                    </Grid>                  
                                ))                  
                            } 
                        </Grid>
                  
                    </Stack> 
                        </Item>
                    </Grid>
                }
                     {mealType === 'drinks' &&
                    <Grid item xs={12} >
                    <Item>
                    <Typography variant="h5" component="div" gutterBottom
                        style={{fontSize:"30px"}}
                        >
                                <b>
                                Drinks & Desserts
                                </b>
                        </Typography>
                        <Divider/>           
                        <Stack spacing={2}>
                        <Grid container spacing={0}>
                 

                        </Grid>
                        
               
                    </Stack> 
                        </Item>
                    </Grid>
                   }

            {mealType === 'rice' && 
                    <Grid item xs={12} >
                    <Item>
                    <Typography variant="h5" component="div" gutterBottom
                        style={{fontSize:"30px"}}
                        >
                                <b>
                                Rice Menu
                                </b>
                        </Typography>
                        <Divider/>           
                        <Stack spacing={2}>
                        <Grid container spacing={0}>
                    
                        </Grid>
           
                    </Stack> 
                        </Item>
                    </Grid>
                }
                   {items.map((snack)=>(  
                    <Grid item  xs={12} md={6}>
                        <Item>
                        <Snacks key={snack._id} id={snack._id} snack={snack}
                        />  
                        </Item>
                        </Grid>                
                                            
                    ))                  
                } 
               
                </Grid>
                
                </Box>
            </Paper >      
        </Paper >
        </> }

        </div>   
   
  );
};

export default Banner;
